export const copyToClipboard = (text: string) => {
	if (navigator.clipboard?.writeText) {
		return navigator.clipboard.writeText(text);
	}

	return new Promise((resolve, reject) => {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.style.position = 'fixed';
		textarea.style.top = '0';
		textarea.style.left = '0';
		textarea.style.width = '1px';
		textarea.style.height = '1px';
		textarea.style.padding = '0';
		textarea.style.border = 'none';
		textarea.style.outline = 'none';
		textarea.style.boxShadow = 'none';
		textarea.style.background = 'transparent';
		document.body.appendChild(textarea);

		textarea.focus();
		textarea.select();

		try {
			const successful = document.execCommand('copy');
			document.body.removeChild(textarea);
			successful
				? console.log('copied')
				: reject(new Error('execCommand returned false'));
		} catch (err) {
			document.body.removeChild(textarea);
			reject(err);
		}
	});
};
